export default __webpack_public_path__ + "static/mailer-ee488a3f7ab53da1202b86a231770f01.jpg";